import { status } from './HttpStatus'

declare interface ApiError extends Error {
  response: Response;
}

const handleError = (error: ApiError, callbacks?: Record<string, CallableFunction> | undefined) => {
  /**
   * Common error handler
   * `callbacks` is an object where:
   *  - key: error status code to be caught. Example: 400
   *  - value: callback to execute when the error with the expected status is caught
   *
   * If an error happens that is outside of the expected statuses,
   * re-throw it, let it propagate
   */
  let errorCaught = false
  if (callbacks === undefined) callbacks = {}

  for (const [status, callback] of Object.entries(callbacks)) {
    const errorStatus = error.response.status.toString()
    if (errorStatus === status) {
      callback()
      errorCaught = true
    }
  }

  if (!errorCaught) {
    if (
      error.response !== undefined &&
      error.response.status !== status.HTTP_401_UNAUTHORIZED &&
      error.response.status !== status.HTTP_403_FORBIDDEN
    ) {
      alert(error)  // TODO
    }
    throw error
  }
}

export { handleError as handle }
